import { render, staticRenderFns } from "./CarFaxReportControl.vue?vue&type=template&id=3ca42506&scoped=true"
import script from "./CarFaxReportControl.vue?vue&type=script&lang=js"
export * from "./CarFaxReportControl.vue?vue&type=script&lang=js"
import "./CarFaxReportControl.vue?vue&type=style&index=0&id=3ca42506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca42506",
  null
  
)

export default component.exports